// extracted by mini-css-extract-plugin
export default {"root":"action_icons-module___root___e545112a"};